import React from "react";
import styles from "./RightSidebar.module.scss";
import classNames from "classnames";
import useMountAnimation from "../../hooks/useMountAnimation";

function RightSidebar({ className, children, sidebarIsOpen: parentShow }) {
  const { show, showClassName, onTransitionEnd } = useMountAnimation(
    parentShow
  );

  return parentShow ? (
    <>
      <div className={classNames(styles.mask)} />
      {show && (
        <div
          className={classNames(
            styles.rightSidebar,
            showClassName ? styles.show : styles.hide,
            className
          )}
          onTransitionEnd={onTransitionEnd}
        >
          {children}
        </div>
      )}
    </>
  ) : (
    <> </>
  );
}

export default RightSidebar;
